
Vue.component('campaigns-merge', require('./CampaignMerge/vue/campaigns-merge.vue').default);

Vue.component('employer-dropdown', require('./EmployerDropdown/vue/employer-dropdown.vue').default);

Vue.component('employer-icons', require('./Employer/vue/employer-icons.vue').default);
Vue.component('employer-notes-wrapper', require('./EmployerNotes/vue/employer-notes-wrapper.vue').default);
Vue.component('employer-notes', require('./EmployerNotes/vue/employer-notes.vue').default);

Vue.component('job-form', require('./Job/vue/job-form.vue').default);
Vue.component('job-list', require('./Job/vue/job-list.vue').default);
Vue.component('campaign-list', require('./Campaign/vue/campaign-list.vue').default);

Vue.component('job-titles-ab-tests', require('./JobTitlesAbTests/vue/job-titles-ab-tests.vue').default);

Vue.component('employer-snippet-list', require('./Snippet/vue/employer-snippet-list.vue').default);
